/**
 * Pile de navigation — mémorise les pages visitées pour alimenter les boutons retour.
 * Persiste en sessionStorage pour survivre aux rafraîchissements.
 *
 * Entrée de pile : { url: string, labelKey: string, labelParams?: object }
 */

const STACK_KEY = 'census_nav_stack';

function getStack() {
  try {
    return JSON.parse(sessionStorage.getItem(STACK_KEY) || '[]');
  } catch {
    return [];
  }
}

function setStack(stack) {
  sessionStorage.setItem(STACK_KEY, JSON.stringify(stack));
}

/** Empile la page qu'on quitte (pour pouvoir y revenir). */
export function pushRoute(entry) {
  const stack = getStack();
  stack.push(entry);
  setStack(stack);
}

/** Retourne l'entrée du dessus de la pile sans la supprimer (ou null si vide). */
export function peekBack() {
  const stack = getStack();
  return stack.length > 0 ? stack[stack.length - 1] : null;
}

/**
 * Si l'URL qu'on vient d'atteindre correspond au sommet de la pile,
 * dépile (l'utilisateur a cliqué le bouton retour de l'appli) et retourne true.
 * Sinon retourne false (navigation vers l'avant).
 * Comparaison sur le path seul (ignore les query params) pour que
 * "#/species" matche "#/species?zone_id=..." stocké dans la pile.
 */
export function popIfBack(url) {
  const stack = getStack();
  if (stack.length === 0) return false;
  const topPath = stack[stack.length - 1].url.split('?')[0];
  const checkPath = url.split('?')[0];
  if (topPath === checkPath) {
    stack.pop();
    setStack(stack);
    return true;
  }
  return false;
}
